module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-maintenance-notification/master-maintenance-notification.component.scss
// module id = ./src/app/master/master-maintenance-notification/master-maintenance-notification.component.scss
// module chunks = main